import updeep from 'updeep';

import { SET_APPLICANTS } from '@src/redux/actions/applicants';

const DEFAULT_STATE = {
  loading: false,
};

export function applicants(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_APPLICANTS:
      return updeep({ [action.openingId]: action.applicants, loading: false }, state);

    default:
      return state;
  }
}
